(() => {
  const locale = document.documentElement.lang.split('-')[0];
  const copy = {"✦ Пробвай с AI": {"ro": "✦ Încearcă previzualizarea AI", "el": "✦ Δοκίμασέ το με AI"}, "Зареждане…": {"ro": "Se încarcă…", "el": "Φόρτωση…"}, "Визуализацията още се зарежда. Опитай отново след малко.": {"ro": "Previzualizarea încă se încarcă. Încearcă din nou peste câteva momente.", "el": "Η προεπισκόπηση φορτώνει ακόμη. Δοκίμασε ξανά σε λίγο."}, "Примери за подходяща снимка на лицето": {"ro": "Exemple de fotografii potrivite pentru personalizare", "el": "Παραδείγματα κατάλληλων φωτογραφιών προσώπου"}};
  const tr = text => copy[text]?.[locale] || text;

  const boot = (scope = document) => {
    scope.querySelectorAll('[href="#mfl-ai-preview"]').forEach(link => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mfl__ai';
      button.textContent = tr('✦ Пробвай с AI');
      button.setAttribute('aria-haspopup', 'dialog');
      const status = document.createElement('span');
      status.className = 'mfl__ai-status';
      status.setAttribute('role', 'status');
      status.hidden = true;
      const question = link.closest('details');
      const supported = () => Boolean(document.querySelector('[data-mfos-ai-source] button.at-button'));
      const updateEligibility = () => {
        if (question) question.hidden = !supported();
        button.hidden = !supported();
      };
      link.replaceWith(button, status);
      updateEligibility();
      if (!supported()) {
        const eligibilityObserver = new MutationObserver(() => {
          updateEligibility();
          if (supported()) eligibilityObserver.disconnect();
        });
        eligibilityObserver.observe(document.body, {childList:true, subtree:true});
        setTimeout(() => eligibilityObserver.disconnect(), 30000);
      }
      button.addEventListener('click', () => {
        const launch = () => {
          const source = document.querySelector('[data-mfos-ai-source] button.at-button');
          if (!source || source.disabled || source.getAttribute('aria-disabled') === 'true') return false;
          button.disabled = false;
          button.textContent = tr('✦ Пробвай с AI');
          status.hidden = true;
          source.click();
          return true;
        };
        if (launch()) return;
        button.disabled = true;
        button.textContent = tr('Зареждане…');
        const observer = new MutationObserver(() => { if(launch()){observer.disconnect();clearTimeout(timeout);} });
        observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-disabled','disabled']});
        const timeout = setTimeout(() => {
          observer.disconnect(); button.disabled = false; button.textContent = tr('✦ Пробвай с AI');
          status.hidden = false; status.textContent = tr('Визуализацията още се зарежда. Опитай отново след малко.');
        }, 10000);
      });
    });
    scope.querySelectorAll('[id$="__faq"] p').forEach(p => {
      if(p.textContent.trim() !== 'instructions_img') return;
      const img = document.createElement('img');
      img.src = 'https://cdn.shopify.com/s/files/1/0259/5507/4119/files/photo-instructions.jpg?v=1693484783';
      img.alt = tr('Примери за подходяща снимка на лицето');
      img.loading = 'lazy'; img.style.maxWidth = '100%'; img.style.borderRadius = '16px';
      p.replaceChildren(img);
    });
    scope.querySelectorAll('[data-mfl-tabs]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = tabs.map(tab => document.getElementById(tab.getAttribute('aria-controls')));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const tabList = root.querySelector('[role="tablist"]');
      let tabDrag = null, draggedTab = false;
      tabList.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        tabDrag = { x: event.clientX, left: tabList.scrollLeft };
        draggedTab = false;
      });
      tabList.addEventListener('pointermove', event => {
        if (!tabDrag) return;
        const delta = event.clientX - tabDrag.x;
        if (!draggedTab && Math.abs(delta) > 6 && tabList.scrollWidth > tabList.clientWidth) {
          draggedTab = true;
          tabList.setPointerCapture(event.pointerId);
          tabList.classList.add('is-dragging');
        }
        if (draggedTab) { event.preventDefault(); tabList.scrollLeft = tabDrag.left - delta; }
      });
      const endTabDrag = () => { tabDrag = null; tabList.classList.remove('is-dragging'); };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => tabList.addEventListener(name, endTabDrag));
      tabList.addEventListener('pointerleave', event => { if (!tabList.hasPointerCapture(event.pointerId)) endTabDrag(); });
      tabList.addEventListener('dragstart', event => event.preventDefault());
      tabList.addEventListener('click', event => {
        if (draggedTab && event.detail !== 0) { event.preventDefault(); event.stopPropagation(); draggedTab = false; }
      }, true);
      tabList.addEventListener('wheel', event => {
        if (event.ctrlKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY) || !window.matchMedia('(pointer:fine)').matches) return;
        const delta = event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? tabList.clientWidth : 1);
        const next = Math.max(0, Math.min(tabList.scrollWidth - tabList.clientWidth, tabList.scrollLeft + delta));
        if (next !== tabList.scrollLeft) { event.preventDefault(); tabList.scrollLeft = next; }
      }, { passive: false });
      let switchVersion = 0;
      let transitions = [];
      const activate = async tab => {
        if (tab.getAttribute('aria-selected') === 'true') return;
        const version = ++switchVersion;
        transitions.forEach(animation => animation.cancel());
        transitions = [];
        const current = panels.find(panel => !panel.hidden);
        const target = document.getElementById(tab.getAttribute('aria-controls'));
        tabs.forEach(t => {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
        });
        const listRect = tabList.getBoundingClientRect(), tabRect = tab.getBoundingClientRect();
        if (tabRect.left < listRect.left || tabRect.right > listRect.right) {
          tabList.scrollTo({ left: tabList.scrollLeft + (tabRect.left < listRect.left ? tabRect.left - listRect.left : tabRect.right - listRect.right), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        }
        if (!reducedMotion.matches && current && current !== target) {
          const outgoing = current.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(6px)'}], {duration:130,easing:'ease-out',fill:'forwards'});
          transitions.push(outgoing);
          await outgoing.finished.catch(() => {});
          if (version !== switchVersion) return;
        }
        panels.forEach(panel => { panel.hidden = panel !== target; });
        transitions.forEach(animation => animation.cancel());
        transitions = [];
        if (!reducedMotion.matches) {
          const incoming = target.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}], {duration:320,easing:'cubic-bezier(.22,.61,.36,1)'});
          transitions.push(incoming);
        }
        root.dispatchEvent(new Event('mfl:change', {bubbles:true}));
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', e => {
          let next;
          if(e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if(e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if(e.key === 'Home') next = 0;
          if(e.key === 'End') next = tabs.length - 1;
          if(next !== undefined){e.preventDefault();activate(tabs[next]);tabs[next].focus();}
        });
      });
    });
    scope.querySelectorAll('[data-mfl-carousel]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready = 'true';
      const rail = root.querySelector('[data-mfl-rail]');
      let drag = null, moved = false;
      rail.addEventListener('pointerdown', e => {
        if(e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = {id:e.pointerId,x:e.clientX,left:rail.scrollLeft}; moved = false;
      });
      rail.addEventListener('pointermove', e => {
        if(!drag) return;
        const delta = e.clientX - drag.x;
        if(Math.abs(delta) > 6 && !moved){moved = true;rail.setPointerCapture(e.pointerId);rail.classList.add('is-dragging');}
        if(moved){e.preventDefault();rail.scrollLeft = drag.left - delta;}
      });
      const endDrag = () => {drag = null;rail.classList.remove('is-dragging');};
      rail.addEventListener('pointerup',endDrag);
      rail.addEventListener('pointercancel',endDrag);
      rail.addEventListener('lostpointercapture',endDrag);
      rail.addEventListener('pointerleave',e=>{if(!rail.hasPointerCapture(e.pointerId)) endDrag();});
      rail.addEventListener('dragstart',e=>e.preventDefault());
      rail.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>boot(),{once:true}); else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
